import { mapCCESItemToCardObject } from '../../../utils/ccesUtils';
import { checkMissingParams, fetchCCESExtensions } from './index';

const getPaidParam = (priceString) => {
  switch (priceString) {
    case 'Free':
      return false;
    case 'Paid':
      return true;
    default:
      undefined;
  }
};
const orderByItems = {
  RATING: {
    ascending: false,
    field: 'rating',
  },
  PRICE_ASC: {
    ascending: true,
    field: 'price',
  },
  PRICE_DESC: {
    ascending: false,
    field: 'price',
  },
  MOST_POPULAR: {
    ascending: false,
    field: 'uniqueDownloads',
  },
  MOST_RECENT: {
    ascending: false,
    field: 'publishedDate',
  },
};

export default async (params, signal) => {
  const paramsRules = {
    searchString: { allowedTypes: ['string'] },
    pageIndex: { allowedTypes: ['number'] },
    pageSize: { allowedTypes: ['number'] },
    publisherId: { allowedTypes: ['string'] },
    product: { allowedTypes: ['array', 'string'] },
    price: { allowedTypes: ['string'] },
    sort: { allowedTypes: ['string'] },
  };

  checkMissingParams(params, [], paramsRules);
  const { searchString, product, price, categoryIds, sort, pageIndex = 0, pageSize = 12, publisherId } = params;

  const requestBody = {
    filters: {
      searchString: searchString,
      hostAppCodes: product === 'All' || !product ? undefined : typeof product === 'string' ? [product] : product,
      paid: getPaidParam(price),
      categoryIds: categoryIds,
      ownerIds: params.publisherId ? [publisherId] : undefined,
    },
    pageIndex: pageIndex,
    pageSize: pageSize,
  };

  if (orderByItems[sort] && sort !== 'RELEVANCE') {
    requestBody.orderBy = [orderByItems[sort]];
  }

  const content = await fetchCCESExtensions(signal, requestBody, params.authToken);
  const response = {
    cloudApps: content.items.map(mapCCESItemToCardObject),
    pages: Math.ceil(content.totalSize / pageSize),
    totalCount: content.totalSize,
  };
  return response;
};
